import './panorama.scss';

import { createElementFromHTML } from '../../utilities/js/helper';

class Panorama {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-panorama',
            hrefAttr: 'data-href',
            uri: '',
            loading: null
        };

        this.settings = Object.assign({}, defaults, options);
        this.$Panorama = element;
        this.isLoading = false;
        this.$loading = null;
    }

    initialize () {
        this.setEvents();
    }

    generateOverlay (image) {
        const $overlay = createElementFromHTML('<figure class="panorama-image" />');
        const $overlayClose = createElementFromHTML('<button class="panorama-image__close action action--close" />');
        const $imageWrapper = createElementFromHTML('<span />');
        const $imageInline = createElementFromHTML('<i />');

        $imageInline.appendChild(image);
        $imageWrapper.appendChild($imageInline);
        $overlay.appendChild($overlayClose);
        $overlay.appendChild($imageWrapper);

        $overlayClose.addEventListener('click', (e) => {
            $overlay.remove();
            e.preventDefault();
        });

        document.body.appendChild($overlay);

        // LITTLE SNIPPED FOR DEVICE-MOVEMENT-IMAGE
        const $image = $overlay.querySelector('img');

        let lastTilt = 0;
        let vibrate = true;
        let startx = 0;
        let tiltAllow = true;
        let actx = 0;
        let modus;

        const handleOrientationChange = (mq) => {
            if (mq.matches) {
                modus = 'portait';
                console.log('modus', modus);
            } else {
                modus = 'landscape';
                console.log('modus', modus);
            }
        };

        // Eine Media Query erstellen, um auf Änderungen der Ausrichtung zu hören
        const mq = window.matchMedia('(orientation: portrait)');

        // Die Funktion registrieren, um auf Änderungen der Media Query zu reagieren
        mq.addEventListener('change', handleOrientationChange);

        const Vibrate = (time) => {
            if ('vibrate' in window.navigator && vibrate) {
                navigator.vibrate([time]);
                vibrate = false;
            }
        };

        const getTranslateX = () => {
            const style = window.getComputedStyle($image);
            const matrix = new DOMMatrix(style.transform);
            return matrix.m41;
        };

        const deviceOrientationHandler = (e) => {
            let distx;
            let usedGyro;

            if (modus === 'portrait') {
                usedGyro = e.gamma;
            } else {
                usedGyro = e.beta;
            }

            if (tiltAllow) {
                if (modus === 'portrait') {
                    distx = actx - (usedGyro * 8) * (-1);

                    if ((usedGyro + 1.5) > lastTilt || (usedGyro - 1.5) < lastTilt) {
                        if (distx > (window.innerWidth / 2) * (-1) || distx < (($image[0].clientWidth - (window.innerWidth / 2)) * (-1))) {
                            Vibrate(25);
                        } else {
                            $image.style.cssText = `transform: translate3d(${distx}px,0,0);
                            -webkit-transform: translate3d(${distx}px,0,0);
                            -moz-transform: translate3d(${distx}px,0,0);`;
                            vibrate = true;
                        }
                        lastTilt = usedGyro;
                    }
                } else {
                    distx = actx - (usedGyro * 8) * (-1);

                    if ((usedGyro + 1.5) > lastTilt || (usedGyro - 1.5) < lastTilt) {
                        if (distx > (window.innerWidth / 2) * (-1) || distx < (($image[0].clientWidth - (window.innerWidth / 2)) * (-1))) {
                            Vibrate(25);
                            actx = getTranslateX();
                        } else {
                            $image.style.cssText = `transform: translate3d(${distx}px,0,0);
                            -webkit-transform: translate3d(${distx}px,0,0);
                            -moz-transform: translate3d(${distx}px,0,0);`;
                            vibrate = true;
                        }
                        lastTilt = usedGyro;
                    }
                }
            }
        };

        if (window.DeviceOrientationEvent) {
            actx = getTranslateX();
            window.addEventListener('deviceorientation', deviceOrientationHandler, false);
        }

        window.addEventListener('orientationchange', (e) => {
            setTimeout(() => {
                $image.style.cssText = `translate3d(-50%,0,0);
                -webkit-transform: translate3d(-50%,0,0);
                -moz-transform: translate3d(-50%,0,0);`;
                tiltAllow = true;
                actx = getTranslateX();
            }, 1000);
        });

        $image.addEventListener('touchstart', (e) => {
            const touchobj = e.changedTouches[0];
            startx = parseInt(touchobj.clientX);
            actx = getTranslateX();
            tiltAllow = false;
            e.preventDefault();
        }, { passive: true });

        $image.addEventListener('touchmove', (e) => {
            const touchobj = e.changedTouches[0];
            const distx = actx - (parseInt(touchobj.clientX) - startx) * (-1);

            if (distx > (window.innerWidth / 2) * (-1) || distx < (($image.clientWidth - (window.innerWidth / 2)) * (-1))) {
                if (distx > (window.innerWidth / 2) * (-1)) {
                    $image.style.cssText = `transform: translate3d(${(window.innerWidth / 2) * (-1)}px,0,0);
                        -webkit-transform: translate3d(${(window.innerWidth / 2) * (-1)}px,0,0);
                        -moz-transform': translate3d(${(window.innerWidth / 2) * (-1)}px,0,0);`;
                } else {
                    $image.style.cssText = `transform: translate3d(${($image.clientWidth - (window.innerWidth / 2)) * (-1)}px,0,0);
                        -webkit-transform: translate3d(${($image.clientWidth - (window.innerWidth / 2)) * (-1)}px,0,0);
                        -moz-transform: translate3d(${($image.clientWidth - (window.innerWidth / 2)) * (-1)}px,0,0);`;
                }
                Vibrate(25);
            } else {
                $image.style.cssText = `transform: translate3d(${distx}px,0,0);
                    -webkit-transform: translate3d(${distx}px,0,0);
                    -moz-transform: translate3d(${distx}px,0,0);`;
                vibrate = true;
            }
            e.preventDefault();
        });

        $image.addEventListener('touchend', (e) => {
            actx = getTranslateX();

            tiltAllow = true;
            e.preventDefault();
        });
    }

    openPanoramaView (imageUri) {
        const img = new Image();
        const $variantImages = document.querySelectorAll('[data-kitchen-variante-image]');

        img.addEventListener('load', () => {
            setTimeout(() => {
                this.generateOverlay(img);
                if (this.settings.loading !== null) {
                    this.$loading.remove();

                    for (let index = 0; index < $variantImages.length; index++) {
                        if ($variantImages[index].parentNode.querySelector('.loading')) {
                            $variantImages[index].parentNode.querySelector('.loading').remove();
                        }
                    }
                }
                this.isLoading = false;
            }, 500);
        });

        img.src = imageUri;
    }

    setEvents () {
        this.$Panorama.addEventListener('click', (e) => {
            const uri = this.$Panorama.getAttribute(this.settings.hrefAttr);

            if (this.isLoading === false) {
                this.isLoading = true;

                if (this.settings.loading !== null) {
                    this.$loading = createElementFromHTML(this.settings.loading);

                    this.$Panorama.append(this.$loading);
                }

                this.openPanoramaView(uri);
            }

            e.preventDefault();
        });
    }
}

export { Panorama };
